// @ts-ignore
export const isIE = typeof document !== 'undefined' && !!document?.documentMode;
